export const todoTabInfo = {
    '1': {
        title: 'Tüm İşler Sekmesi',
        color: 'blue',
        content: 'Bu sekme tüm işleri gösterir.'
    },
    '2': {
        title: 'Yeni Eklenenler Sekmesi',
        color: 'red',
        content: 'Bu sekme yeni eklenen işleri gösterir.'
    },
    '3': {
        title: 'Yapılacaklar Sekmesi',
        color: 'orange',
        content: 'Bu sekme yapılacakları gösterir.'
    },
    '4': {
        title: 'Devam Edenler Sekmesi',
        color: 'cyan',
        content: 'Bu sekme devam eden işleri gösterir.'
    },
    '5': {
        title: 'Tamamlananlar Sekmesi',
        color: 'green',
        content: 'Bu sekme tamamlanan işleri gösterir.'
    },
    '6': {
        title: 'Çalışılmayanlar Sekmesi',
        color: 'dark',
        content: 'Bu sekme çalışılmayan işleri gösterir.'
    },
    '7': {
        title: 'Tahkime Hazırlar Sekmesi',
        color: 'purple',
        content: 'Bu sekme tahkime hazır kaza dosyalarını gösterir.'
    },
    '8': {
        title: 'Tahkimdekiler Sekmesi',
        color: 'info',
        content: 'Bu sekme tahkimde bulunan dosyaları gösterir.'
    },
    '9': {
        title: 'İcradakiler Sekmesi',
        color: 'primary',
        content: 'Bu sekme icrada bulunan dosyaları gösterir.'
    },
    '10': {
        title: 'Kapak Bekleyenler Sekmesi',
        color: 'success',
        content: 'Bu sekme kapak bekleyen dosyaları gösterir.'
    },
    '11': {
        title: 'Kapalı Dosyalar Sekmesi',
        color: 'secondary',
        content: 'Bu sekme kapatılmış kaza dosyalarını gösterir.'
    }
};
